/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  getUsageInfo() {
    return axios.get(`${this.url}/usage_info`);
  }

  getLimits() {
    return axios.get(`${this.url}/limits`);
  }

  updatePassword(id, { current_password, password, password_confirmation }) {
    return axios.post(`${this.url}/${id}/update_password`, {
      current_password,
      password,
      password_confirmation,
    });
  }
}

export default new Agents();
